import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import { pagArmazenagemFailure, pagArmazenagemRequest, pagArmazenagemSuccess } from './actions';

export function* loadPagArmazenagem({ payload }: ReturnType<typeof pagArmazenagemRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getPagadores&token=${state.auth.token}`,
      {
        inscricoesEstaduais: payload.inscricaoAtiva,
        centroDistribuicao: payload.cddAtivo,
      }
    );
    yield put(pagArmazenagemSuccess(response.data.pagadores));
  } catch (error: any) {
    yield put(pagArmazenagemFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar o pagador da armazenagem, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
